import jump from 'jump.js'

export default function scrollTop() {
  jump('#root', { duration: 500 })
}
